import {HttpClient,HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {SERVER_API_URL} from 'src/app/app.constants';
import {IUnderwriterMySuffix} from 'src/app/shared/model/underwriter-my-suffix.model';
import {createRequestOption} from 'src/app/shared/util/request-util';


type EntityResponseType = HttpResponse<IUnderwriterMySuffix>;
type EntityArrayResponseType = HttpResponse<IUnderwriterMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class UnderwriterMySuffixService {
    

    private resourceUrl = SERVER_API_URL + 'api/underwriters';

    constructor(private http: HttpClient) { }

    create(underwriter: IUnderwriterMySuffix): Observable<EntityResponseType> {
        return this.http.post<IUnderwriterMySuffix>(this.resourceUrl, underwriter, { observe: 'response' });
    }

    update(underwriter: IUnderwriterMySuffix): Observable<EntityResponseType> {
        return this.http.put<IUnderwriterMySuffix>(this.resourceUrl, underwriter, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterMySuffix>(`${this.resourceUrl}/view/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterMySuffix[]>(`${this.resourceUrl}/info`, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    accessPlatform(id: number): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${this.resourceUrl}/access-platform/${id}`, { observe: 'response' });
    }

    licensedQuery(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterMySuffix[]>(this.resourceUrl + '/licenced-countries', { params: options, observe: 'response' });
    }

    licenseExcludedquery(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterMySuffix[]>(this.resourceUrl + '/licence-excluded-countries', {
            params: options,
            observe: 'response'
        });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterMySuffix[]>(this.resourceUrl + '/all', { params: options, observe: 'response' });
    }
    getAllActiveunderwriter(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<IUnderwriterMySuffix[]>(this.resourceUrl + '/active', { params: options, observe: 'response' });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<IUnderwriterMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }

    checkForUnderwriterInPolicy(id: any) {
        return this.http.get<any>(SERVER_API_URL+`api/check-for-underwriters-in-policies/${id}`, { observe: 'response' });
    }
    
    checkStandardSurveyEnabled(): Observable<HttpResponse<any>> {
        return this.http.get<any>(`${SERVER_API_URL}api/users/insurance-companies-underwriters/standard-survey`, { observe: 'response' });
    }

}
